import { LogLevel } from '@azure/msal-browser';
import { ILogger } from '../Logger';

export const getMsalConfig = (logger: ILogger) => ({
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URL,
    postLogoutRedirectUri: process.env.REACT_APP_LOGOUT_URL,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean,
      ) => {
        if (!process.env.REACT_APP_ALLOW_LOGGING_PII && containsPii) {
          return;
        }

        switch (level) {
          case LogLevel.Warning:
            logger.logWarning(message);
            return;
          case LogLevel.Error:
            logger.logError(message);
            break;
          case LogLevel.Verbose:
          case LogLevel.Info:
          case LogLevel.Trace:
          default:
        }
      },
    },
  },
});
